import React from 'react';
import { withRouter } from 'react-router-dom';
import { GAKEY } from './constants.js';
// import { GA_TRACKING_ID } from '../config';

class GoogleAnalytics extends React.Component {
  UNSAFE_componentWillUpdate({ location, history }) {
    const { gtag } = window;

    if (location.pathname === this.props.location.pathname) {
      // don't log identical link clicks (nav links likely)
      return;
    }

    if (history.action === 'PUSH' && typeof gtag === 'function') {
      gtag('config', GAKEY, {
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname,
      });
    }
  }

  render() {
    return null;
  }
}

export default withRouter(GoogleAnalytics);
